import React from "react";
import { LoginUsernameStyled } from "./loginUsername.styles";
import LoginUsernameInputs from "../../containerSmall/loginUsernameInputs/loginUsernameInputs.component";

import { connect } from "react-redux";
import { fetchLoginUserNameAsync } from "../../redux/login/login.actions";

const LoginUsername = ({ fetchLoginUserNameAsync }) => {
  const handle_loginBtn_click = () => {
    // alert("hi");
    fetchLoginUserNameAsync();
  };

  return (
    <LoginUsernameStyled>
      <LoginUsernameInputs />

      <div className="d-flex flex-column-reverse flex-sm-row align-items-center justify-content-between mt-4">
        <div className="flex-basis--50 text-muted mt-3 mt-sm-0">
          نام کاربری یا رمز عبور خود را فراموش کرده‌ام
        </div>
        <div className="flex-basis--50">
          <button className="btn--yellow w-100" onClick={handle_loginBtn_click}>
            ورود
          </button>
        </div>
      </div>
    </LoginUsernameStyled>
  );
};

// const mapStateToProps = createStructuredSelector({
//   selectLoginPassword: selectLoginPassword,
//   selectLoginUsername: selectLoginUsername,
// });
const mapDispatchToProps = (dispatch) => ({
  fetchLoginUserNameAsync: (x) => dispatch(fetchLoginUserNameAsync(x)),
});

export default connect(null, mapDispatchToProps)(LoginUsername);
